"use strict";
/*
 * Created on 01 25 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ReleaseType_1 = require("../../release/model/ReleaseType");

var ReleaseWorkflowType_1 = require("../../release/model/ReleaseWorkflowType");

var Role_1 = require("../../user/model/Role");
/**
 * @author Jaroslav Sevcik
 */


var SelloutDescription =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutDescription, _DomainObject_1$Domai);

  function SelloutDescription(basic, identification, priceCalculation, responsibilities, releaseTypes, //only "sellout"
  workflowTypes, targetCondition, endingOfValidity, notification) {
    var _this;

    _classCallCheck(this, SelloutDescription);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutDescription).call(this));
    _this.basic = basic;
    _this.identification = identification;
    _this.priceCalculation = priceCalculation;
    _this.responsibilities = responsibilities;
    _this.releaseTypes = releaseTypes;
    _this.workflowTypes = workflowTypes;
    _this.targetCondition = targetCondition;
    _this.endingOfValidity = endingOfValidity;
    _this.notification = notification;
    return _this;
  }

  return SelloutDescription;
}(DomainObject_1.DomainObject);

exports.SelloutDescription = SelloutDescription;

SelloutDescription.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutDescription.name);
  return {
    basic: builder.str('basic').withDescription({
      multiline: true
    }),
    identification: builder.str('identification').withDescription({
      multiline: true
    }),
    priceCalculation: builder.str('priceCalculation').withDescription({
      multiline: true
    }),
    responsibilities: builder.listOf(builder.obj('responsibilities', Role_1.Role.schema, function (mat) {
      return new Role_1.Role(mat.name);
    })),
    releaseTypes: builder.listOf(builder.senum('releaseTypes', ReleaseType_1.ReleaseType, CodebookLookupSequence_1.CodebookLookupSequence.ReleaseType)),
    workflowTypes: builder.listOf(builder.senum('workflowTypes', ReleaseWorkflowType_1.ReleaseWorkflowType, CodebookLookupSequence_1.CodebookLookupSequence.ReleaseWorkflowType)),
    targetCondition: builder.str('targetCondition').withDescription({
      multiline: true
    }),
    endingOfValidity: builder.str('endingOfValidity').withDescription({
      multiline: true
    }),
    notification: builder.str('notification').withDescription({
      multiline: true
    })
  };
}();